// extracted by mini-css-extract-plugin
export var avatarContainer = "_3y-0";
export var gray = "_3y-f";
export var green = "_3y-c";
export var icon = "_3y-9";
export var image = "_3y-1";
export var lg = "_3y-6";
export var md = "_3y-5";
export var presenceDot = "_3y-b";
export var red = "_3y-d";
export var sm = "_3y-4";
export var status = "_3y-a";
export var xl = "_3y-7";
export var xs = "_3y-3";
export var xxl = "_3y-8";
export var xxs = "_3y-2";
export var yellow = "_3y-e";